import React from 'react';
import { BookingSection } from '../components/BookingSection';
export function ContactPage() {
  return <div data-id="element-739">
      {/* Page Header */}
      <div className="relative py-24 px-4 sm:px-6 lg:px-8 text-center overflow-hidden bg-black" data-id="element-740">
        <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=1600&q=80" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-20" data-id="element-741" />
        <div className="relative z-10" data-id="element-742">
          <p className="text-[#822433] font-bold text-sm uppercase tracking-widest mb-3" style={{
          color: '#a30000'
        }} data-id="element-743">
            Get in Touch
          </p>
          <h1 className="text-4xl sm:text-5xl font-black text-white" data-id="element-744">
            Contact Us
          </h1>
          <div className="w-12 h-0.5 mx-auto mt-4 mb-4" style={{
          background: '#FECB00'
        }} data-id="element-745" />
          <p className="text-gray-400 text-base max-w-xl mx-auto" data-id="element-746">
            Schedule a service, ask a question, or just say hello. We're here
            24/7.
          </p>
        </div>
      </div>
      <BookingSection data-id="element-747" />
    </div>;
}